import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { HOME_URL } from 'constants/env';
import ROUTES from 'utils/routes';

// Header logo link: the tenant's own site when REACT_APP_HOME_URL is set, otherwise the app root.
const BrandLink = ({ children }) =>
  HOME_URL ? <a href={HOME_URL}>{children}</a> : <Link to={ROUTES.root}>{children}</Link>;

BrandLink.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BrandLink;
